import React, { useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import SwiperCore, { Navigation, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/components/navigation/navigation.min.css";

SwiperCore.use([Navigation, Autoplay]);

const HeroArea = ({ events = [] }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const base = process.env.PUBLIC_URL || "";

  if (!events.length) {
    return (
      <section className="hn-hero">
        <div className="hn-hero-inner">
          <span className="hn-hero-badge">What&apos;s happening in Namibia</span>
          <h1 className="hn-hero-title">HypeNa Events & Experiences</h1>
          <p style={{ color: "rgba(255,255,255,0.8)", marginBottom: 24 }}>
            Discover local events and activities. Check back soon for upcoming events.
          </p>
          <div className="hn-hero-cta">
            <Link to={`${base}/events`} className="hn-btn hn-btn-primary">
              View all events
            </Link>
          </div>
        </div>
      </section>
    );
  }

  const sliderOptions = {
    slidesPerView: 1,
    loop: true,
    autoplay: { delay: 5000, disableOnInteraction: false },
    onSlideChange: (swiper) => setActiveIndex(swiper.realIndex),
    navigation: true,
    className: "hn-hero-swiper",
  };

  return (
    <section className="hn-hero">
      <Swiper {...sliderOptions}>
        {events.map((event) => {
          const att = event.attributes || {};
          const cityName = att.address?.city?.data?.attributes?.name || "";
          return (
            <SwiperSlide key={event.id}>
              <div className="hn-hero-inner">
                <span className="hn-hero-badge">
                  <i className="bi bi-calendar2-week" /> {moment(att.startDate).format("MMMM DD, YYYY")}
                </span>
                <h1 className="hn-hero-title">{att.title}</h1>
                <ul className="hn-hero-meta" style={{ listStyle: "none", padding: 0, display: "flex", flexWrap: "wrap", gap: 20 }}>
                  <li><span><i className="bi bi-pin-map" /> {cityName}</span></li>
                  <li><span><i className="bi bi-tag" /> {att.ticketPrice === 0 ? "Free" : `N$ ${att.ticketPrice}`}</span></li>
                  {att.link && <li><span><i className="bi bi-link" /> Event link</span></li>}
                </ul>
                <div className="hn-hero-cta">
                  <Link to={`${base}/events/${event.id}`} className="hn-btn hn-btn-primary">
                    Book now
                  </Link>
                  <Link to={`${base}/events/${event.id}`} className="hn-btn hn-btn-outline">
                    View details
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
      {events.length > 1 && (
        <div className="hn-hero-pagination" style={{ position: "absolute", bottom: 24, left: "50%", transform: "translateX(-50%)", zIndex: 2, display: "flex", gap: 8 }}>
          {events.map((_, i) => (
            <span
              key={i}
              style={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                background: i === activeIndex ? "var(--hn-primary)" : "rgba(255,255,255,0.4)",
                transition: "background 0.3s",
              }}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default HeroArea;
